import { PlanStatusEnum } from 'pages/users/entities';
import { IUser, IUserPlan } from 'utils/types';

const normalizeStorageLimitOverride = (value: unknown): number | null => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;
};

export const handleTransformUserData = (data: any) => {
  delete data.tempPlanName;
  delete data.tempPlanStatus;
  delete data?.plan.name;

  if (data?.enterpriseProducts.length) {
    data.enterpriseProducts = data?.enterpriseProducts.map((ep: any) => ep?.id);
  }

  const hasStorageLimitOverride = data?.hasStorageLimitOverride;
  const storageLimitOverride = hasStorageLimitOverride
    ? normalizeStorageLimitOverride(data?.storageLimitOverride)
    : null;

  const isOverride = !!data?.isOverride;
  const maxProjectsCount = Number(data?.maxProjectsCount);

  data.plan = {
    ...data.plan,
  };

  if (typeof hasStorageLimitOverride === 'boolean') {
    data.plan.hasStorageLimitOverride = hasStorageLimitOverride;
    data.plan.storageLimitOverride = storageLimitOverride;
  }

  // Backend Joi requires a positive integer; omit when not overriding or invalid
  // (e.g. Number(null/undefined) → 0 would 422 on Storage Details save).
  if (isOverride && Number.isFinite(maxProjectsCount) && maxProjectsCount > 0) {
    data.plan.maxProjectsCount = maxProjectsCount;
  }

  delete data?.isOverride;
  delete data?.maxProjectsCount;
  delete data?.hasStorageLimitOverride;
  delete data?.storageLimitOverride;
  delete data?.planStorageLimitGb;

  return data;
};

export const handleSwitchUserTabByErrors = (errors: any) => {
  if (errors.firstName || errors.lastName || errors.email) return '1';
  if (errors.plan) return '2';
  if (errors.hasStorageLimitOverride || errors.storageLimitOverride) return '3';

  return false;
};

export const defaultValuesAdapter = (user: IUser) => {
  const {
    firstName,
    lastName,
    maxProjectsCount,
    isOverride,
    email,
    plan,
    isSuperAdmin = false,
    hasStorageLimitOverride = false,
    storageLimitOverride = null,
  } = user;
  const enterpriseProducts = user.enterpriseProducts || [];
  const tempPlanName = plan?.name;
  const tempPlanStatus = { prevTempPlanStatus: null, currentTempPlanStatus: plan?.status };

  let adaptedPlan: IUserPlan | null = null;

  if (user?.plan) {
    const { invoiceId, productId, status, name, trialEndDate, nextChargeDate } = user.plan;

    const adaptedPlanFields: IUserPlan = {
      invoiceId,
      productId,
      status,
    };

    if (name !== 'Trial' && status === PlanStatusEnum.TRIALING) {
      adaptedPlanFields.nextChargeDate = trialEndDate;
    } else if (trialEndDate) {
      adaptedPlanFields.trialEndDate = trialEndDate;
    } else if (nextChargeDate) {
      adaptedPlanFields.nextChargeDate = nextChargeDate;
    }

    adaptedPlan = adaptedPlanFields;
  }

  return {
    tempPlanName,
    tempPlanStatus,
    firstName,
    lastName,
    email,
    isSuperAdmin,
    enterpriseProducts,
    maxProjectsCount,
    isOverride,
    hasStorageLimitOverride,
    storageLimitOverride:
      hasStorageLimitOverride && typeof storageLimitOverride === 'number'
        ? storageLimitOverride
        : '',
    plan: adaptedPlan,
  };
};
